
























import { Vue, Component, Prop } from 'vue-property-decorator'

export interface ButtonGroupOptions {
    name: string
    value: any
}

@Component({ name: 'v-button-group' })
export default class VButtonGroup extends Vue {
    @Prop({ type: Array, required: true })
    options!: ButtonGroupOptions[]

    @Prop()
    value: any

    @Prop({ type: String, required: true })
    name!: string
}
